var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWebappLiked = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 12,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#webapp_liked_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.786 5.173c-.02-1.356-.788-2.692-1.97-3.242-.6-.28-1.296-.35-2.022-.119-.604.192-1.21.585-1.794 1.204-.584-.619-1.19-1.012-1.794-1.204a2.742 2.742 0 0 0-2.023.119C1.003 2.48.234 3.817.214 5.173v.006c0 1.978 1.177 3.73 2.422 4.96.63.62 1.293 1.126 1.872 1.479.29.176.563.318.806.417.232.095.474.166.686.166.212 0 .454-.072.686-.166.243-.1.517-.24.806-.417a10.569 10.569 0 0 0 1.872-1.479c1.245-1.23 2.422-2.982 2.422-4.96v-.006Z",
  fill: "#58636A"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "webapp_liked_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(0 .938)",
  d: "M0 0h12v12H0z"
})))));
export default SvgWebappLiked;